// 言語別URL生成: th → "/path" / en → "/en/path" / jp → "/jp/path"
export function langPath(lang, subpath) {
  if (lang === 'th') return subpath;
  return `/${lang}${subpath}`;
}

// 現在のURLから言語プレフィックスを除いたベースパスを返す
function getBasePath() {
  const p = window.location.pathname.replace(/\/+$/, '') || '/';
  return p.replace(/^\/(en|jp)/, '') || '/';
}

// 言語切替後のURLを生成（現在のページ種別を維持）
export function switchLangUrl(newLang) {
  return langPath(newLang, getBasePath());
}

// 言語設定をlocalStorageに保存
export function saveLangPref(lang) {
  try { localStorage.setItem('nunt_lang', lang); } catch (_) {}
}

// lang属性のマッピング（BCP 47）
export const LANG_ATTR = { th: 'th', en: 'en', jp: 'ja' };
